import { useLocationStorage } from './useLocationStorage'
import { useGps } from './useGps'

const DISTANCE_THRESHOLD = 300

export function useLocationCompare() {
    const location = useLocation()
    const { getCurrentGpsCoords } = useGps()
    const {
        savePopupShownData,
        getLastPopupShownData,
        hasCooldownPassed
    } = useLocationStorage()

    const getDistanceInMeters = (
        lat1: number,
        lon1: number,
        lat2: number,
        lon2: number
    ) => {
        const R = 6371000
        const toRad = (v: number) => (v * Math.PI) / 180

        const dLat = toRad(lat2 - lat1)
        const dLon = toRad(lon2 - lon1)

        const a =
            Math.sin(dLat / 2) ** 2 +
            Math.cos(toRad(lat1)) *
            Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) ** 2

        return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    }

    const showLocationChangePopup = (coords: any) => {
        savePopupShownData(coords.latitude, coords.longitude)

        const { openLocationChangePopup, currentLocationCoord } =
            useLocationPicker()

        currentLocationCoord.value = coords
        openLocationChangePopup()
    }

    const checkIfLocationsAreSame = async () => {
        
        if (!location.gps?.latitude || !location.gps?.longitude) return

        const current = await getCurrentGpsCoords()
        if (!current?.latitude || !current?.longitude) return

        const distance = getDistanceInMeters(
            location.gps.latitude,
            location.gps.longitude,
            current.latitude,
            current.longitude
        )

        if (distance <= DISTANCE_THRESHOLD) return

        const last = getLastPopupShownData()

        if (
            hasCooldownPassed() ||
            (last &&
                getDistanceInMeters(
                    last.lat,
                    last.lng,
                    current.latitude,
                    current.longitude
                ) > DISTANCE_THRESHOLD)
        ) {
            showLocationChangePopup(current)
        }
    }

    return { checkIfLocationsAreSame }
}
